<template>
    <label :class="['flex', { disabled }]">
        <div class="switch">
            <input
                v-bind="$attrs"
                type="checkbox"
                :checked="modelValue"
                @change="$emit('update:modelValue', $event.target.checked)"
            />
            <span class="slider round"></span>
        </div>
        <div
            v-if="hasDefaultSlot"
            class="mx-2"
        >
            <slot />
        </div>
    </label>
</template>

<script>
import { slotIsUsed } from '@helpers/dom';

export default {
    name: 'ToggleSwitch',
    inheritAttrs: false,
    props: {
        modelValue: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['update:modelValue'],
    computed: {
        hasDefaultSlot() {
            return slotIsUsed(this.$slots.default);
        },
    },
};
</script>

<style lang="scss" scoped>
.switch {
    position: relative;
    width: 43px;
    height: 22px;
    &.disabled {
        input:checked + .slider {
            @apply bg-slate-400;
        }
    }
}

.switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

.slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: theme('colors.slate.300');
    -webkit-transition: 0.4s;
    transition: 0.4s;
}

.slider:before {
    position: absolute;
    content: '';
    height: 20px;
    width: 20px;
    left: 1px;
    bottom: 1px;
    background-color: white;
    -webkit-transition: 0.4s;
    transition: 0.4s;
}

input:checked + .slider {
    @apply bg-green-500;
}

input:focus + .slider {
    box-shadow: 0 0 1px #2196f3;
}

input:checked + .slider:before {
    -webkit-transform: translateX(21px);
    -ms-transform: translateX(21px);
    transform: translateX(21px);
}

/* Rounded sliders */
.slider.round {
    border-radius: 34px;
}

.slider.round:before {
    border-radius: 50%;
}
</style>
